import { render, staticRenderFns } from "./LicensePlanBetaConfiguration.vue?vue&type=template&id=391f3630&"
import script from "./LicensePlanBetaConfiguration.vue?vue&type=script&lang=js&"
export * from "./LicensePlanBetaConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports